import createVueComponent from '../createVueComponent';

const Sigma = createVueComponent('SigmaIcon', [
  ['path', { d: 'M18 7V4H6l6 8-6 8h12v-3' }],
]);

export default Sigma;
